import React, { useEffect, useState } from 'react'
import { GoogleMap } from 'react-google-maps'
import RiderPortalMap from 'src/components/riders/rider-portal/google/map/Map'
import { googleMapService } from 'src/services/GoogleMap'
import { IGetGoogleMapPolyline, ILatitudeAndLongitude, ILocationV2 } from 'src/types/location'
import { IRiderPortalMapViewProps } from 'src/types/rider-portal-map'

const CONTAINER_STYLE = {
  height: '100%',
  width: '100%'
}

const RiderPortalMapView = ({
  center,
  className = '',
  dropOff,
  isMarkerDraggable = false,
  operator,
  pickUp,
  serviceZones = [],
  showPolyline = false,
  handleMarkerDragged = () => console.log('Marker dragged.')
}: IRiderPortalMapViewProps) => {
  const [polyline, setPolyline] = useState<google.maps.LatLng[]>([])
  const [portalMap, setPortalMap] = useState<GoogleMap | null>(null)

  const handleMapMounted = (map: GoogleMap) => {
    setPortalMap(map)
  }

  const validateLocationValues = (
    type: 'dropOff' | 'operator' | 'pickUp',
    location: ILocationV2 | ILatitudeAndLongitude | null
  ) => {
    return location && location.latitude && location.longitude
      ? { coordinates: { lat: location.latitude, lng: location.longitude }, type }
      : { coordinates: null, type }
  }

  const mapMarkers = [
    { ...validateLocationValues('dropOff', dropOff) },
    { ...validateLocationValues('pickUp', pickUp) },
    {
      ...(operator
        ? validateLocationValues('operator', operator)
        : { coordinates: null, type: 'operator' as 'dropOff' | 'operator' | 'pickUp' })
    }
  ]

  /** Automatically toggle to center and adjust zoom of the map to show all markers */
  const fitPortalMapMarkers = () => {
    const markerCoordinates = mapMarkers.filter(({ coordinates }) => coordinates !== null)
    if (!portalMap || markerCoordinates.length === 0) {
      return
    }

    const bounds = new window.google.maps.LatLngBounds()
    markerCoordinates.forEach(({ coordinates }) => bounds.extend(coordinates))

    if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
      const extendPoint1 = new google.maps.LatLng(
        bounds.getNorthEast().lat() + 0.01,
        bounds.getNorthEast().lng() + 0.01
      )
      const extendPoint2 = new google.maps.LatLng(
        bounds.getNorthEast().lat() - 0.01,
        bounds.getNorthEast().lng() - 0.01
      )
      bounds.extend(extendPoint1)
      bounds.extend(extendPoint2)
    }

    portalMap.fitBounds(bounds)
  }

  const handlePolylineParsing = async (locationDetails: IGetGoogleMapPolyline) => {
    const data = (await googleMapService.getDirections(locationDetails)) as google.maps.DirectionsResult
    const route = data.routes ? data.routes[0] : null
    if (route && route.overview_polyline) {
      const decodedPolyline = google.maps.geometry.encoding.decodePath(route.overview_polyline.toString())
      setPolyline(decodedPolyline)
    }
  }

  useEffect(() => {
    if (portalMap) {
      fitPortalMapMarkers()

      if (
        showPolyline &&
        (dropOff && dropOff.latitude && dropOff.longitude) &&
        (pickUp && pickUp.latitude && pickUp.longitude)
      ) {
        const locationDetails = {
          destination: { lat: dropOff.latitude, lng: dropOff.longitude },
          origin: { lat: pickUp.latitude, lng: pickUp.longitude }
        }
        handlePolylineParsing(locationDetails)
      }
    }
  }, [dropOff, pickUp, portalMap])

  return (
    <React.Fragment>
      <RiderPortalMap
        center={center || { lat: 47.60504593630763, lng: -122.33409830890035 }}
        containerElement={<div style={CONTAINER_STYLE} />}
        isMarkerDraggable={isMarkerDraggable}
        mapElement={<div className={className} style={CONTAINER_STYLE} />}
        markers={mapMarkers}
        polyline={polyline}
        serviceZones={serviceZones}
        handleMarkerDragged={handleMarkerDragged}
        onMapMounted={handleMapMounted}
      />
    </React.Fragment>
  )
}

export default RiderPortalMapView



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/google/map/RiderPortalMapView.tsx